export default __webpack_public_path__ + "static/media/M19.f4ee79a9.svg";